export default {
	page:{
		devstatus: {
			title: "Device Status",
			desc: "This page shows the current status and some basic settings of the device.",
			blkTitle: {
				system:  "System", 
				version: "Version", 
				cpu_memory: "CPU and Memory"
			}
		},
		port: {
			title: "Port",
			desc: "This page is used to display port information and configure ports.",
		},
		portstatus: {
			title: "Port Config",
			desc: "This page is used to configure ports.",
			blkTitle: {
				portStatusTable:  "Port Config"
			}
		},
		portoptical: {
			title: "Port Optical",
			desc: "This page shows the port current optical.",
			blkTitle: {
				portOpticalTable:  "Port Optical"
			}
		},
		portstatistics: {
			title: "Port Statistics",
			desc: "This page shows the port current statistics.",
			blkTitle: {
				portStatisticsTable:  "Port Statistics"
			}
		},
		ontstatus: {
			title: "Ont List",
			desc: "This page shows the current status of Ont List.",
			blkTitle: {
				ontStatusTable:  "Ont List"
			}
		},
		vlan: {
			title: "VLAN Config",
			desc: "This page shows the current vlan config.",
			blkTitle: {
				vlan:  "VLAN Config"
			}
		},
		mac: {
			title: "MAC Table",
			desc: "This page shows the current MAC table.",
			blkTitle: {
				mac:  "MAC Table"
			}
		},
		lacp: {
			title: "LACP Config",
			desc: "This page shows the information of link aggregation and related configuration.",
			blkTitle: {
				lacp: "LACP Status",
				port: "LACP Port Config"
			}
		},
		igmpconfig: {
			title: "IGMP Config",
			desc: "This page shows the current IGMP and related configuration.",
			blkTitle: {
				igmpSnoopTable: "IGMP Snooping Config"
			}
		},
		ipconfig: {
			title: "IP Config",
			desc: "This page shows the current IP configuration.",
			blkTitle: {
			}
		},
		ipconfigif: {
			title: "IP Interface Config",
			desc: "This page shows the current IP interface configuration.",
			blkTitle: {
				vlanIfTable: "IP Interface Config"
			}
		},
		ipconfigifaddr: {
			title: "IP Interface Address Config",
			desc: "This page shows the current IP interface address and related configuration.",
			blkTitle: {
				vlanIfAddrTable: "IP Interface Address Config"
			}
		},
		ipconfigstatic: {
			title: "IP Static Route Config",
			desc: "This page shows the current IP static route and related configuration.",
			blkTitle: {
				staticRouteTable: "IP Static Route Config"
			}
		}
	},
	
	system: {
		"sysdesc": {"k": "System description", "v":  "GPON"},
		"sysoid": {"k": "System object id", "v": "1.3.6.1.4.1.13464.1.10.7.1"},
		"sysname": {"k": "System name", "v": "ad"},
		"sysruntime": {"k": "System run time", "v": "16 day 17 hour 29 minute 11 second"},
		"sysloc" : {"k": "System location", "v": "sample sysLocation factory default"},
		"switchtemp": {"k": "Chipset switch temp", "v": "38.5 celsius "},
		"gpontemp": {"k": "Chipset gpon temp", "v": "33.0 celsius"},
		"admincont": {"k": "Administrator contact", "v": "http://"},
		"proname": {"k": "Product name", "v": "Switch CASSETTE OLT GPON"},
		"port": {"k": "Interface of system", "v": "22"},
		"gpon": {"k": "Interface of pon", "v": "16"},
	},
	version: {
		"softplat": {"k": "Software platform", "v": "Broadband Network Platform Software"},
		"softver": {"k": "Software version", "v": "GPON CASSETTE OLT V100R001B01D001P008"},
		"copyright": {"k": "Copyright", "v": "Copyright (C) 2019-2020"},
		"md5": {"k": "Host MD5", "v": "efd9ed9020c9b918d7d1d24c84c17a11 (size: 11629935 bytes)"},
		"compltime": {"k": "Compiled time", "v": "Nov 13 2019 17:00:00"},
		"processor": {"k": "Processor", "v": "CORTEX-A9 MP, 1GHz"},
		"ram": {"k": "SDRAM(bytes)", "v": "1G"},
		"flash": {"k": "Flash memory(bytes)", "v": "32M"},
		"mac": {"k": "MAC address", "v": "00:0a:5a:9b:18:06"},
		"serial": {"k": "Product serial no.", "v": "123456789"},
		"hardver": {"k": "Hardware version", "v": "V2.0"},
		"bootver": {"k": "Bootrom version", "v": "V2.2"},
		"epldver": {"k": "EPLD version", "v": "V1.0"},
	},
	cpu_memory: {
		"cpu": {"k": "CPU Idle", "v": "182 %"},
		"tolmem":{"k": "Total Memory", "v": "10240 MB"},
		"freemem": {"k": "Free Memory", "v": "1121 MB"}
	},
  portStatusTable: {
  	"title": {"port": "Port", "desc": "Destination", "link": "Link", "shutdown": "shutdown", "speed": "Speed", "pri": "Priority", "pvid": "Pvid", "mode": "Mode", "tagvlan": "Tag Vlan", "untagvlan": "Utag Vlan" },
  	"data": [
  		{"port": "g0/1", "desc": "a", "link": "up", "shutdown": 'false', "speedlist":[],"speed": "f2500", "pri": "0", "pvid": "-", "mode": "access", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/2", "desc": "b", "link": "down", "shutdown": 'false',"speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/3", "desc": "c", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/4", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/5", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/6", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/7", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/8", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/9", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/10", "desc": "", "link": "up", "shutdown": 'false', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/11", "desc": "", "link": "up", "shutdown": 'true', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/12", "desc": "", "link": "up", "shutdown": 'true', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/13", "desc": "", "link": "up", "shutdown": 'true', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/14", "desc": "", "link": "up", "shutdown": 'true', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/15", "desc": "", "link": "up", "shutdown": 'true', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "g0/16", "desc": "", "link": "up", "shutdown": 'true', "speedlist":[], "speed": "f2500", "pri": "0", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "e1/1", "desc": "", "link": "up", "shutdown": 'true', "speedlist":["1000", "auto"], "speed": "auto", "pri": "1", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "e1/2", "desc": "", "link": "up", "shutdown": 'true', "speedlist":["1000", "auto"], "speed": "1000", "pri": "2", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "e1/3", "desc": "", "link": "up", "shutdown": 'true', "speedlist":["1000", "auto"], "speed": "auto-1000", "pri": "3", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "e1/4", "desc": "", "link": "up", "shutdown": 'true', "speedlist":["1000", "auto"], "speed": "auto-1000", "pri": "4", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "e2/1", "desc": "", "link": "up", "shutdown": 'true', "speedlist":["1000", "10000"], "speed": "f10000", "pri": "5", "pvid": "1", "mode": "trunk", "tagvlan": "1-405", "untagvlan": "2-50" },
  		{"port": "e2/2", "desc": "", "link": "up", "shutdown": 'true', "speedlist":["1000", "10000"], "speed": "f1000", "pri": "0", "pvid": "1", "mode": "hybrid", "tagvlan": "1-405", "untagvlan": "2-50" },
  	]
  },
  portOpticalTable:{
	"brief": {"port": "Port", 
		"ostatus": "O-status", "pstatus": "P-state", "ttype":"T-Type", "mtype":"M-type", "mstype":"Ms-type",  "utype":"U-type", "ctype":"C-type", "wavelen":"Wave", "transferdis":"Dis", "ddm":"DDM", "vendorname":"Name",
		"serial":"M.SN", "manudate":"M.Date", "vendorname1":"Name", "vendorpn":"VenPN" ,"vendorrevi":"venRevi",
		"temp": "Temp", "voltage": "Volt", "biascurrent": "Bias", "biashthr":"BiasHiT", "biaslthr":"BiasLoT", "rx": "RX", "rxhthr":"RXHiT", "rxlthr":"RXLoT", "tx": "TX", "txhthr":"TXHiT", "txlthr":"TXLoT" },
	"title": {"port": "Port", 
		"comminfo":"Common information", 
		"ostatus": "Optical Module status", "pstatus": "Port state", "ttype":"Transceiver Type", "mtype":"Module type", "mstype":"Module sub-type",  "utype":"Used type", "ctype":"Connector Type", "wavelen":"WaveLength(nm)", "transferdis":"Transfer Distance(m)", "ddm":"Digital Diagnostic Monitoring", "vendorname":"VendorName",
		"manuinfo":"Manufacture information",
		"serial":"Manu. Serial Number", "manudate":"Manufacturing Date", "vendorname1":"VendorName", "vendorpn":"Vendor PN" ,"vendorrevi":"Vendor Revision",
		"diaginfo":"Diagnostic information", 
		"temp": "Temperature(celsius)", "voltage": "Voltage(V)", "biascurrent": "Bias Current(mA)", "biashthr":"Bias High Threshold(mA)", "biaslthr":"Bias Low  Threshold(mA)", "rx": "RX Power(dBm)", "rxhthr":"RX Power High Threshold(dBm)", "rxlthr":"RX Power Low  Threshold(dBm)", "tx": "TX Power(dBm)", "txhthr":"TX Power High Threshold(dBm)", "txlthr":"TX Power Low  Threshold(dBm)" },
	"data": [
		{"port": "e2/1", 
		 "ostatus": "Online", "pstatus": "Off", "ttype":"SFP", "mtype":"10G BASE-SR", "mstype":"-",  "utype":"-", "ctype":"SC", "wavelen":"850", "transferdis":"3000(50um)", "ddm":"YES", "vendorname":"HTT",
		 "serial":"14030650004", "manudate":"2014-03-27", "vendorname1":"HTT", "vendorpn":"HSP85192-SR", "vendorrevi":"",
	 	 "temp": "34", "voltage": "3.36", "Biascurrent": "8.84", "Biashthr":"90.00", "Biaslthr":"0.10", "rx": "No optical power", "rxhthr":"-1.00", "rxlthr":"-11.9", "tx": "-1.6", "txhthr":"-1.0", "txlthr":"-5.00" },
	 	{"port": "e2/1", 
		 "ostatus": "Online", "pstatus": "Off", "ttype":"SFP", "mtype":"GPON", "mstype":"Class C+",  "utype":"ONT", "ctype":"LC", "wavelen":"850", "transferdis":"3000(50um)", "ddm":"YES", "vendorname":"HTT",
		 "serial":"14030650004", "manudate":"2014-03-27", "vendorname1":"HTT", "vendorpn":"HSP85192-SR", "vendorrevi":"",
	 	 "temp": "34", "voltage": "3.36", "Biascurrent": "8.84", "Biashthr":"90.00", "Biaslthr":"0.10", "rx": "No optical power", "rxhthr":"-1.00", "rxlthr":"-11.9", "tx": "-1.6", "txhthr":"-1.0", "txlthr":"-5.00" },
	]
  },
  portStatisticsTable:{
	"brief":{"port":"Port", "rxpack":"Rx Packets", "rxbytes":"Rx Bytes", "rxdisc":"Rx Disc", "rxuni":"Rx Uni", "rxmulti":"Rx Multi", "rxbroad":"Rx Broad", "rxerror":"Rx Errors", "rxfcs":"Rx FCSErr", "rxsymb":"Rx SymErr", "rxfalse":"Rx FalCarr", "rxrunts":"Rx Runts", "rxgiants":"Rx Giants", 
		"txpack":"Tx Packets", "txbytes":"Tx Bytes", "txdisc":"Tx Disc", "txuni":"Tx Uni", "txmulti":"Tx Multi", "txbroad":"Tx Broad", "txerror":"Tx Errors", "txdefer":"Tx Deferr", "txcolli":"Tx Colli", "txlatecolli":"Tx LatColli", 
		"b64":"64", "b65":"65-127", "b128":"128-255", "b256":"256-511", "b512":"512-1023", "b1024":"1024-1518"},
	"title":{"port":"Port", "rxpack":"Rx Packets", "rxbytes":"Rx Bytes", "rxdisc":"Rx Discarded", "rxuni":"Rx Unicasts", "rxmulti":"Rx Multicasts", "rxbroad":"Rx Broadcasts", "rxerror":"Rx Errors", "rxfcs":"Rx FCS error", "rxsymb":"Rx Symbol error", "rxfalse":"Rx False carrier", "rxrunts":"Rx Runts", "rxgiants":"Rx Giants", 
		"txpack":"Tx Packets", "txbytes":"Tx Bytes", "txdisc":"Tx Discarded", "txuni":"Tx Unicasts", "txmulti":"Tx Multicasts", "txbroad":"Tx Broadcasts", "txerror":"Tx Errors", "txdefer":"Tx Deferred", "txcolli":"Tx Collisions", "txlatecolli":"Tx Late collisions", 
		"b64":"64 byte packets", "b65":"65-127 byte packets", "b128":"128-255 byte packets", "b256":"256-511 byte packets", "b512":"512-1023 byte packets", "b1024":"1024-1518 byte packets"},
	"data":[
		{"port":"e2/1", "rxpack":"0", "rxbytes":"2722565", "rxdisc":"0", "rxuni":"0", "rxmulti":"0", "rxbroad":"0", "rxerror":"0", "rxfcs":"0", "rxsymb":"0", "rxfalse":"0", "rxrunts":"0", "rxgiants":"0", 
	"txpack":"0", "txbytes":"10789471", "txdisc":"0", "txuni":"0", "txmulti":"0", "txbroad":"0", "txerror":"0", "txdefer":"0", "txcolli":"0", "txlatecolli":"0", 
	"b64":"0", "b65":"0", "b128":"0", "b256":"0", "b512":"0", "b1024":"0"},
	]
  },
  ontListTable: {
    "title": { "ontid": "ONT", "sn": "SN", "devtype": "Device-type", "time": "Up/Down-time","status": "Status", "statusInfo": "Running/Reason",  "ws": "W/S", "detail": "Detail", "desc": "Description" },
    "data": [
      { "ontid": "0/1/1", "sn": "GNXS-012a2d10", "devtype": "c40-210", "time": "6d17h52m","status": "online", "statusInfo": "Normal", "ws": "working", "desc": "abcdefghijklmnopqrstuvwxyz abcdefghijklmnopqrstuvwxyz" },
      { "ontid": "0/2/3", "sn": "GPON-5aa700f1", "devtype": "n40-400-1h", "time": "6d17h52m","status": "online", "statusInfo": "Normal", "ws": "working", "desc": "Description" },
      { "ontid": "0/3/4", "sn": "GPON-5aa700f2", "devtype": "n40-400-1h", "time": "6d17h52m","status": "online", "statusInfo": "Normal", "ws": "working", "desc": "Description" },
      { "ontid": "0/5/5", "sn": "GPON-5aa700f3", "devtype": "n40-400-1h", "time": "6d17h52m","status": "offline", "statusInfo": "Normal", "ws": "working", "desc": "Description" },
    ]
  },
  ontUpgradeList: {
    "title": { "ontid": "ONT", "sn": "ONT SN", "status": "Status", "devtype": "Device-type", "sw": "Software Version" },
    "data": [
      { "ontid": "0/1/1", "sn": "GNXS-012a2d10", "status": "online", "devtype": "c40-210", "sw": "R4.2.94.038" },
      { "ontid": "0/1/3", "sn": "GPON-5aa700f1", "status": "online", "devtype": "n40-400-1h", "sw": "R4.2.94.038" },
      { "ontid": "0/3/4", "sn": "GPON-5aa700f2", "status": "online", "devtype": "n40-400-1h", "sw": "R4.2.94.036" },
      { "ontid": "0/5/5", "sn": "GPON-5aa700f3", "status": "offline", "devtype": "n40-400-1h", "sw": "R4.2.94.038" },
    ]
  },
  ontUpgradeStatus: {
    "title": { "ontid": "ONT", "active": "Active-version", "inactive": "Inactive-version", "status": "Status", "timer": "Timer" },
    "data": [
      { "ontid": "0/1/2", "active": "R4.2.56.058", "inactive": "R4.2.56.058", "status": "50%", "timer": "N" },
      { "ontid": "0/2/2", "active": "R4.2.56.058", "inactive": "R4.2.56.058", "status": "50%", "timer": "N" },
    ]
  },
  ontInfo: {
    "ONT": { "k": "ONT", "v": "0/1/1" },
    "Description": { "k": "Description", "v": "-" },
    "Type": { "k": "Type", "v": "-" },
    "Status": { "k": "Status", "v": "online" },
    "W/S": { "k": "W/S", "v": "working" },
    "Distance(m)": { "k": "Distance(m)", "v": "<10" },
    "Vendor ID": { "k": "Vendor ID", "v": "CSCO" },
    "Software Version": { "k": "Software Version", "v": "1.1.3.12/1.1.3.3" },
    "Firmware Version": { "k": "Firmware Version", "v": "N40-429-1" },
    "Equipment ID": { "k": "Equipment ID", "v": "4GE-2POTS-CATV-WIFI" },
    "SN": { "k": "SN", "v": "GCOM-5a000001" },
    "Password": { "k": "Password", "v": "123456" },
    "LOID": { "k": "LOID", "v": "000a5a000001" },
    "LOID Password": { "k": "LOID Password", "v": "000001" },
    "Uplink PON ports": { "k": "Uplink PON ports", "v": "1" },
    "ETH/POTS/TDM/MOCA ports": { "k": "ETH/POTS/TDM/MOCA ports", "v": "4/2/0/0" },
    "CATV ANI/UNI ports": { "k": "CATV ANI/UNI ports", "v": "1/1" },
    "T-CONTs/GEM ports": { "k": "T-CONTs/GEM ports", "v": "31/127" },
    "Traffic Schedulers": { "k": "Traffic Schedulers", "v": "31" },
    "PQs in T-CONT 1-8": { "k": "PQs in T-CONT 1-8", "v": "8/8/8/8/8/8/8/8" },
    "DBA method": { "k": "DBA method", "v": "SR" },
    "IP configuration": { "k": "IP configuration", "v": "Not support" },
    "Type of flow control": { "k": "Type of flow control", "v": "GEMPORT CAR and PQ SCHEDULED" },
    "TX power cut off": { "k": "TX power cut off", "v": "Not Support" },
    "Online/Offline time": { "k": "Online/Offline time", "v": "10:34:50   2021/04/27" },
    "Up/Down time": { "k": "Up/Down time", "v": "0 day(s)  0 hour(s) 57 minute(s)" }
  },
  ontOpmInfo: {
    "voltage": { "k": "Power Feed Voltage(V)", "v": "3.22" },
    "rx": { "k": "RX Optical Power(dBm)", "v": "-15.768  (OLT TX: 3.967)" },
    "tx": { "k": "TX Optical Power(dBm)", "v": "2.420    (OLT RX: -15.686)" },
    "bias": { "k": "Laser Bias Current(mA)", "v": "10.300" },
    "temperature": { "k": "Temperature(C)", "v": "33.60" },
    "catvRx": { "k": "CATV RX Power(dBm)", "v": "-" },
    "catvPower": { "k": "CATV Output Power(dBmV)", "v": "-" }
  },
  ontPort: {
    "title": { "port": "Port", "enable": "Enable","linkstatus": "LinkStatus", "mode": "Mode" },
    "data": [
      { "port": "1", "enable": "enable" ,"linkstatus": "linkUp" , "mode": "Gigabit Full"},
      { "port": "2", "enable": "enable", "linkstatus": "linkUp" , "mode": "100BaseT Half"},
      { "port": "3", "enable": "enable", "linkstatus": "linkDown" , "mode": "-"},
      { "port": "4", "enable": "disable", "linkstatus": "linkDown" , "mode": "-"}
    ]
  },
  ontStatistics: {
    "upstreamFrames": { "k": "Upstream frames", "v": "179616590" },
    "upstreamBytes": { "k": "Upstream bytes", "v": "40009495591" },
    "downstreamFrames": { "k": "Downstream frames", "v": "238509373" },
    "downstreamBytes": { "k": "Downstream bytes", "v": "113691546938" },
    "upTraffic": { "k": "Up traffic (kbps)", "v": "0" },
    "downTraffic": { "k": "Down traffic (kbps)", "v": "7" },
  },
  ontMacTable: {
    "title": { "mac": "MAC Address", "vlan": "VLAN ID", "ont": "ONT", "sn": "SN", "gem": "ID/GEM" },
    "data": [
      { "mac": "00:01:02:03:04:00", "vlan": "11", "ont": "0/1/1", "sn": "GPON-e3502431", "gem": "1/256" },
      { "mac": "00:01:02:03:05:00", "vlan": "21", "ont": "0/1/1", "sn": "GPON-e3502432", "gem": "1/256" },
      { "mac": "00:01:02:03:06:00", "vlan": "31", "ont": "0/1/1", "sn": "GPON-e3502433", "gem": "1/256" },
    ]
  },
  ontProfile:
    [
      { "config": "----------------------------------------------------------------" },
      { "config": "DBA profile 1 name INDEX_1" },
      { "config": "type 4 max 1000000" },
      { "config": "----------------------------------------------------------------" },
      { "config": "VLAN profile 1 name INDEX_1" },
      { "config": "translate old-vlan 100 new-vlan 100" },
      { "config": "----------------------------------------------------------------" },
      { "config": "Line profile 1 name INDEX_1" },
      { "config": "device type c40-100" },
      { "config": "tcont 1 profile dba 1" },
      { "config": "gemport 1 tcont 1 vlan-profile 1" },
      { "config": "flow 1 port eth 1 default vlan 100" }
    ],
  ontOpticalList: {
    "title": { "ontid": "ONT", "volt": "Voltage(V)", "rx": "Rx-power(OLT-tx)(dbm)", "tx": " Tx-power(OLT-rx)(dbm)", "bias": "Bias(mA)" },
    "data": [
      { "ontid": "0/1/1", "volt": "3.2", "rx": "-21.156(5.424)", "tx": "2.134(-21.540)", "bias": "12.54" },
      { "ontid": "0/2/3", "volt": "3.5", "rx": "-21.156(5.424)", "tx": "2.134(-21.540)", "bias": "11.55" },
      { "ontid": "0/5/4", "volt": "3.4", "rx": "-21.156(5.424)", "tx": "2.134(-21.540)", "bias": "12.96" },
      { "ontid": "0/5/5", "volt": "3.6", "rx": "-21.156(5.424)", "tx": "2.134(-21.540)", "bias": "12.987" }
    ]
  },
  pppoeplusConfig: {
    "title": { "format": "Format", "type": "Type", "circuitId": "Circuit ID", "remoteId": "Remote ID" },
    "data": [
      { "format": "ASCII", "type": "self-defined", "circuitId": "client-mac olt-ip-int-vlan 100 hostname", "remoteId": 'client-mac "aaa" hostname' },
    ]
  },
  pppoeplusPortConfig: {
    "title": { "port": "Port", "pppoeplus": "PPPoE Plus", "trust": "Trust", "strategy": "Strategy", "dropPadi": "Drop Padi", "dropPado": "Drop Pado" },
    "data": [
      { "port": "g0/1", "pppoeplus": "disable", "trust": "trust", "strategy": "replace", "dropPadi": "disable", "dropPado": "disable" },
      { "port": "g0/2", "pppoeplus": "enable", "trust": "untrust", "strategy": "keep", "dropPadi": "enable", "dropPado": "enable" },
      { "port": "g0/3", "pppoeplus": "disable", "trust": "trust", "strategy": "replace", "dropPadi": "disable", "dropPado": "disable" },
      { "port": "g0/4", "pppoeplus": "disable", "trust": "trust", "strategy": "replace", "dropPadi": "disable", "dropPado": "disable" },
      { "port": "e1/1", "pppoeplus": "disable", "trust": "trust", "strategy": "replace", "dropPadi": "disable", "dropPado": "disable" },
      { "port": "e1/2", "pppoeplus": "enable", "trust": "untrust", "strategy": "keep", "dropPadi": "enable", "dropPado": "enable" },
      { "port": "e1/3", "pppoeplus": "disable", "trust": "trust", "strategy": "replace", "dropPadi": "disable", "dropPado": "disable" },
      { "port": "e1/4", "pppoeplus": "disable", "trust": "trust", "strategy": "replace", "dropPadi": "disable", "dropPado": "disable" },
    ]
  },
  snmpCommunity: {
    "title": { "community": "Community", "type": "Access Type", "permit": "Permit" },
    "data": [
      { "community": "public", "type": "ro", "permit": "Permit" },
      { "community": "private", "type": "rw", "permit": "Permit" },
    ]
  },
  snmpTrapHost: {
    "title": { "ip": "Host", "version": "Version", "securityName": "Security Name" },
    "data": [
      { "ip": "1.1.1.1", "version": "2c", "securityName": "public" },
    ]
  },
  vlanTable:{
  	"title": {"vlanid": "VLAN ID", "name": "VLAN name", "status": "VLAN status", "member": "VLAN member", "statictag": "Static tagged ports", "staticuntag": "Static untagged Ports", "dynamictag": "Dynamic tagged ports"},
  	"data": [
  		{"vlanid": "1", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "2", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "3", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "4", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "5", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "6", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "7", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" },
  		{"vlanid": "8", "name": "vlan", "status": "static", "member": "e1/1-e2/2", "statictag": "e1/1-e1/4", "staticuntag": "e2/1", "dynamictag": "e2/2" }
    ]
  },
  macTable:{
	"title": {"mac": "MAC Address", "vid": "VLAN ID", "port": "port", "status": "status"},
	"data": [
		{"mac": "00:01:02:03:04:00", "vid": "11", "port": "e1/2", "status": "dynamic"},
		{"mac": "00:01:02:03:05:00", "vid": "21", "port": "e2/2", "status": "dynamic"},
		{"mac": "00:01:02:03:06:00", "vid": "31", "port": "e1/2", "status": "static"},
		{"mac": "00:01:02:03:07:00", "vid": "41", "port": "e1/3", "status": "dynamic"},
		{"mac": "00:01:02:03:08:00", "vid": "51", "port": "e1/2", "status": "dynamic"},
  	]
  },
  lacpTable:{
	"title": {"port": "Port", "state": "State", "akey": "A-Key", "okey": "O-Key", "pri": "Priority", "logport": "Logic-port", "actstate": "Actor-state"},
	"data": [
		{
			"channel": 0,
			"dynamic": true,
			"member": [
				{"port": "e1/1", "state": "bndl", "akey": "3", "okey": "2", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e1/2", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e1/3", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e2/1", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e2/2", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
			]
		},
		{
			"channel": 1,
			"dynamic": false,
			"member": [
				{"port": "e1/1", "state": "bndl", "akey": "3", "okey": "4", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e1/2", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e1/3", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e2/1", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e2/2", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
			]
		},
		{
			"channel": 2,
			"dynamic": true,
			"member": [
				{"port": "e1/1", "state": "bndl", "akey": "3", "okey": "5", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e1/2", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e1/3", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e2/1", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
				{"port": "e2/2", "state": "bndl", "akey": "3", "okey": "3", "pri": "128", "logport": "25", "actstate": "10111100"},
			]
		},
	]	
  },
  lacpNeighborTable:{
	"title": {"local": "Local", "neighbor": "Neighbor", "key": "Key", "npri": "Priority", "id": "ID", "timeout": "Timeout", "neistate": "Nei-state"},
	"data": [
		{
			"channel": 0,
			"member": [
				{"local": "e1/1", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e1/2", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e1/3", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e1/4", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e2/1", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
  			]
  		},
		{
			"channel": 2,
			"member": [
				{"local": "e1/1", "neighbor": "1", "key": "4", "npri": "129", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e1/2", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e1/3", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e1/4", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
				{"local": "e2/1", "neighbor": "1", "key": "4", "npri": "128", "id": "000291533001", "timeout": "65(90)", "neistate": "10111100"},
  			]
  		},
	]
  },
  lacpPortTable:{
	"title": {"port": "Port", "channel": "Channel", "mode": "Mode"},
	"data": [
		{"port": "e1/1", "channel": "0", "mode": "on"},
		{"port": "e1/2", "channel": "1", "mode": "passive"},
		{"port": "e1/3", "channel": "", "mode": ""},
		{"port": "e1/4", "channel": "3", "mode": "on"},
		{"port": "e2/1", "channel": "4", "mode": "passive"},
		{"port": "e2/2", "channel": "5", "mode": "passive"},
	],
	"maxchannel": 16,
  },
  igmpSnoopTable:{
  	"title": { "portName": "Port Name", "mcastVlan": "Multicast VLAN" },
  	"data": [
  		{
			"globalIgmpSnoop": "0",
			"portInfo": [
	  		{ "portId": "1", "portName": "g0/1",	"mcastVlan": "1" },
	  		{ "portId": "2", "portName": "g0/2",	"mcastVlan": "2" },
	  		{ "portId": "9", "portName": "e1/2",	"mcastVlan": "3" }
    		]
  		}
  	]
  },
  vlanIfTable:{
  	"title": {"index": "Index", "ifName": "I/F Name", "vlanId": "VLAN/Sub VLAN", "primaryIp": "Primary IP", "ifShutdown": "Shutdown", "status": "Status" },
  	"data": [
  		{"index": "1", "ifType": "0", "ifName": "VLAN-IF1",  		"vlanId": "1",		"primaryIp": "", "ifShutdown": "false", "status": "Up"},
  		{"index": "2", "ifType": "0", "ifName": "VLAN-IF4",  		"vlanId": "4",		"primaryIp": "", "ifShutdown": "false", "status": "Down"},
  		{"index": "3", "ifType": "0", "ifName": "VLAN-IF10", 		"vlanId": "10",		"primaryIp": "", "ifShutdown": "false", "status": "Up"},
  		{"index": "4", "ifType": "0", "ifName": "VLAN-IF30", 		"vlanId": "30",		"primaryIp": "", "ifShutdown": "true", "status": "Admin Down"},
  		{"index": "5", "ifType": "1", "ifName": "superVLAN-IF2",	"vlanId": "None", "primaryIp": "", "ifShutdown": "false", "status": "Down"}
    ]
  },
  vlanIfAddrTable:{
  	"title": { "index": "Index", "ipAddr": "IP Address", "ipMask": "IP Mask", "ifPrimary": "Primary" },
  	"data": [
  		{
			"ifName": "VLAN-IF1",
			"ifIp": [
	  		{ "index": "1",	"ipAddr": "192.168.1.5",	"ipMask": "255.255.255.0",	"ifPrimary": "true" },
	  		{ "index": "2",	"ipAddr": "192.168.5.5",	"ipMask": "255.255.255.0",	"ifPrimary": "fasle" },
	  		{ "index": "3",	"ipAddr": "192.168.8.5",	"ipMask": "255.255.255.0",	"ifPrimary": "fasle" }
    		]
  		},
  		{
			"ifName": "VLAN-IF3",
			"ifIp": [
	  		{ "index": "1",	"ipAddr": "192.168.3.5",	"ipMask": "255.255.255.0",	"ifPrimary": "true" }
    		]
  		}
  	]
  },
  staticRouteTable:{
  	"title": {"index": "Index", "destIp": "Dest IP", "subnetMask": "Subnet Mask", "proto": "Protocol", "metric": "Metric", "nexthop": "Nexthop", "outIntf": "Out I/F", "isActive": "Active" },
  	"data": [
  		{"index": "1", "destIp": "192.168.5.0", "subnetMask": "255.255.255.0",  		"proto": "static",		"metric": "0", "nexthop": "192.168.3.15", "outIntf": "VLAN-IF5", "isActive": "true" },
  		{"index": "2", "destIp": "192.168.6.0", "subnetMask": "255.255.255.0",  		"proto": "static",		"metric": "1", "nexthop": "192.168.4.1", "outIntf": "VLAN-IF4", "isActive": "false" },
  		{"index": "3", "destIp": "192.168.7.0", "subnetMask": "255.255.255.0", 		"proto": "static",		"metric": "5", "nexthop": "192.168.1.15", "outIntf": "VLAN-IF1", "isActive": "true" }
    ]
  },

  dbaProfileTable:{
	"title": {"profileid": "Profile ID", "name": "Profile name", "type":"type", "fir":"Fixed BW", "cir":"Assured BW", "pir":"Maxmium Bw" },
  },

  vlanProfileTable:{
	  "title": {"profileid": "Profile ID", "name": "Profile name", "vlanruleid": "VLAN RuleID", "vlanaction":"VLAN Action", "oltvlan":"Old VlAN", "oldpri":"Old priority", "newvlan":"New Vlan", "newpri":"New Priority"}
  },

  usProfileTable:{
	  "title": {"profileid": "Profile ID", "name": "Profile name", "queuepri":"Queue Priority", "cir":"CIR(Kbps)", "pir":"PIR(Kbps)", "cbs":"CBS(Kbytes)", "pbs":"PBS(Kbytes)"}
  },

  dsProfileTable:{
	  "title": {"profileid": "Profile ID", "name": "Profile name", "pir":"PIR(Kbps)"}
  },

  ruleProfileTable:{
	"title": {"profileid": "Profile ID", "name": "Profile name", "mode":"Auth Mode", "loid":"Loid/Sn", "lopw":"Loid Pw/Sn Pw", "line":"Line List", "defline":"Defalt Line"}
  },

  lineProfilePriTable:{
	"title": {"profileid": "Profile ID", "name": "Profile name", "devicetype":"Device Type", "mappingmode":"Mapping Mode", "trafficmode":"Traffic Mode"}
  },
  uniqueProfileTable: {
    "title": { "ontid": "ONT", "name": "Profile name", "desc": "Description", "alarm": "Alarm ProfileID", "multicast": "Multicast ProfileID", "config": "More Config" },
    "data": [{ "ontid": "0/3/2", "name": "ttt", "desc": "GPON", "alarm": "1", "multicast": "2" },
    { "ontid": "0/3/3", "name": "test", "desc": "GPON", "alarm": "2", "multicast": "2" },
    { "ontid": "0/3/4", "name": "ttt", "desc": "GPON", "alarm": "2", "multicast": "2" }]
  },
  uniqueGemportTable: {
    "title": { "gemport": "Gemport", "vlanProfile": "Vlan Profile", "usProfile": "Us Traffic Profile", "dsProfile": "Ds Traffic Profile" },
    "data": [{ "gemport": "3", "vlanProfile": "1", "usProfile": "2", "dsProfile": "1" }]
  },
  uniqueTcontTable: {
    "title": { "tcont": "Tcont ID", "dbaProfile": "DBA Profile" },
    "data": [{ "tcont": "3", "dbaProfile": "1" }]
  },
  uniqueAgentTable: {
    "title": { "proxyServer": "Proxy Server", "registrarServer": "Registrar Server", "outboundProxy": "Outbound Proxy", "signalPort": "Signal Port" },
    "data": [{ "proxyServer": "aaa", "registrarServer": "ccc", "outboundProxy": "bbb", "signalPort": "222" }]
  },
  uniqueSipUserAddrTable: {
    "title": { "mode": "Mode", "vlan": "VLAN", "pri": "Pri", "host": "Host", "ip": "IP", "mask": "mask", "gateway": "gateway", "primaryDns": "primaryDns", "secondaryDns": "secondaryDns" },
    "data": [{ "mode": "dhcp", "vlan": "11", "pri": "2", "host": "1", "ip": "", "mask": "", "gateway": "", "primaryDns": "", "secondaryDns": "1" }]
  },
  alarmProfileTable: {
    "title": { "profileid": "Profile ID", "name": "Profile name", "rxlow": "Rx Low(dbm)", "rxhigh": "Rx High(dbm)", "txlow": "Tx Low(dbm)", "txhigh": "Tx High(dbm)" },
    "data": [{ "profileid": "2", "name": "INDEX_12", "rxlow": "-4", "rxhigh": "-1", "txlow": "2", "txhigh": "5" },]
  },
  multicastProfileTable: {
    "title": { "profileid": "Profile ID", "name": "Profile name", "entry": "Entry" },
    "data": [{ "profileid": "1", "name": "mult test" }]
  },
  multicastEntryTable: {
    "title": { "index": "Index", "type": "Type", "startip": "Start IP", "endip": "End IP", "srcip": "Src IP", "vlan": "Vlan", "port": "Port", "detail": "Detail" },
    "data": [{ "index": "2", "type": "permit", "startip": "224.1.1.6", "endip": "224.100.100.100", "srcip": "100.100.100.100", "vlan": "100", "port": "10" }]
  },
  multicastEntryInfo: {
    "index": { "k": "Index", "v": "2" },
    "type": { "k": "Type", "v": "preview" },
    "startIp": { "k": "Start IP", "v": "224.2.2.1" },
    "endIp": { "k": "End IP", "v": "224.2.2.66" },
    "srcip": { "k": "Src IP", "v": "10.2.2.3" },
    "vlan": { "k": "Vlan", "v": "100" },
    "port": { "k": "Port", "v": "2" },
    "bandwidth": { "k": "Bandwidth", "v": "200000" },
    "duration": { "k": "Duration", "v": "300" },
    "interval": { "k": "Interval", "v": "32" },
    "resetTime": { "k": "Reset Time", "v": "1" },
    "times": { "k": "Times", "v": "5" }
  },
  findList: {
    "title": { "port": "Port", "index": "Index", "sn": "Sn", "lastFind": "LastFind", "findCnt": "FindCnt", "detail": "Detail" },
    "data": [{ "port": "g0/1", "index": "1", "sn": "GCOM-16a00001", "lastFind": "2021/06/09 20:12:22", "findCnt": "2", "detail": "" },
    { "port": "g0/2", "index": "1", "sn": "GCOM-16a00001", "lastFind": "2021/06/09 20:12:22", "findCnt": "2", "detail": "" }],
    "count": 2
  },
  findConfig: {
    "title": { "port": "Port", "find": "Find", "interval": "Interval(s)", "age": "Age", "ageTime": "Aging Time(s)", "distanceMin": "Distance Min(km)", "distanceMax": "Distance Max(km)" },
    "data": [{ "port": "g0/1", "find": "enable", "interval": "20", "age": "enable", "ageTime": "300", "distanceMin": "0", "distanceMax": "20" }]
  },
  sntpClientConfig: {
    "title": { "status": "Sntp Client", "mode": "Mode", "server": "Sntp Server" },
    "data": [{ "status": "enable", "mode": "unicast", "server": "1.1.1.5" }]
  },
  stormControlTable:{
	"title": { "port": "Port", "bcastRate": "broadcast(pps)", "mcastRate": "multicast(pps)", "ucastRate": "unicast(pps)" },
	"data": [ /* Rate 0 代表 disabled */
			{ "port": "g0/1", "bcastRate": "49984", "mcastRate": "0", "ucastRate": "0" },
			{ "port": "g0/2", "bcastRate": "49984", "mcastRate": "0", "ucastRate": "0" },
			{ "port": "e1/2", "bcastRate": "49984", "mcastRate": "0", "ucastRate": "0" }
		  	]
  },
  dhcpOption82Config: {
	/* key: switch, format, verboseNodeId, circuitInfoFormat, remoteInfoFormat, otherInfoFormat */
    "title": { "switch": "DHCP Option82", "format": "Format", "verboseNodeId": "Verbose NodeId", "circuitInfoFormat": "Circuit Info Format", "remoteInfoFormat": "Remote Info Format", "otherInfoFormat": "Other Info Format" },
    "data": [
      { "switch": "enable", "format": "verbose", "verboseNodeId": "hostname", "circuitInfoFormat": "hex" , "remoteInfoFormat": "hex", "otherInfoFormat": "hex"},
    ]
  },
  dhcpOption82PortConfig: {
	/* key: port, switch, cIdStr, cIdUdStr, rIdStr, rIdUdStr */
	/* 		cIdStr -- circuit-id string 
			cIdUdStr -- circuit-id user-defined format string 
			rIdStr -- remote-id string 
			rIdUdStr -- remote-id user-defined format string 
	*/
    "title": { "port": "Port", "switch": "DHCP Option82", "cIdStr": "CircuitID String", "cIdUdStr": "CircuitID UserDefined String", "rIdStr": "RemoteID String", "rIdUdStr": "RemoteID UserDefined String" },
    "data": [
      { "port": "g0/1", "switch": "enable", "cIdStr": "aaa", "cIdUdStr": "sysname", "rIdStr": "ccc", "rIdUdStr": "gemport" },
      { "port": "g0/2", "switch": "enable", "cIdStr": "aaa", "cIdUdStr": "sysname", "rIdStr": "ccc", "rIdUdStr": "gemport" },
      { "port": "g0/3", "switch": "enable", "cIdStr": "aaa", "cIdUdStr": "sysname", "rIdStr": "ccc", "rIdUdStr": "gemport" },
      { "port": "g0/4", "switch": "enable", "cIdStr": "aaa", "cIdUdStr": "sysname", "rIdStr": "ccc", "rIdUdStr": "gemport" },
      { "port": "e1/1", "switch": "enable", "cIdStr": "bbb", "cIdUdStr": "sysname", "rIdStr": "ddd", "rIdUdStr": "gemport" },
      { "port": "e1/2", "switch": "enable", "cIdStr": "bbb", "cIdUdStr": "sysname", "rIdStr": "ddd", "rIdUdStr": "gemport" },
      { "port": "e1/3", "switch": "enable", "cIdStr": "bbb", "cIdUdStr": "sysname", "rIdStr": "ddd", "rIdUdStr": "gemport" },
      { "port": "e1/4", "switch": "enable", "cIdStr": "bbb", "cIdUdStr": "sysname", "rIdStr": "ddd", "rIdUdStr": "gemport" },
    ]
  },
  loadHistoryTable: {
    "title": { "file": "File", "time": "Time", "loadstatus": "Load-status" },
    "data": [
      { "file": "bootrom_flash.bin", "time": "2021/09/28 18:41", "loadstatus": "SUCCESS" },
	  { "file": "host.arj", "time": "2021/09/28 18:46", "loadstatus": "SUCCESS" },
	  { "file": "epld.xxx", "time": "2021/09/28 18:50", "loadstatus": "SUCCESS" },
	  { "file": "ont.xxx", "time": "2021/09/28 18:56", "loadstatus": "SUCCESS" },
    ]
  },

}
